export { FormRegistration } from "./FormRegistration";
